// Fixed release type taxonomy - keep in sync with backend VALID_RELEASE_TYPES
export const RELEASE_TYPES = [
  { value: 'exclusive', label: 'Exclusive' },
  { value: 'vip-packs', label: 'VIP Packs' },
  { value: 'dj-intro', label: 'DJ Intro' },
  { value: 'pop-hits', label: 'Pop Hits' },
  { value: 'dj-tools', label: 'DJ Tools' },
  { value: 'free-download', label: 'Free Download' },
];

export const releaseLabel = (val) =>
  RELEASE_TYPES.find((t) => t.value === val)?.label || val;
